import { useEffect, useState } from "react";
// eslint-disable-next-line
import dayjs from "dayjs";
// eslint-disable-next-line
import Scheduler from "./scheduler";
import { getAppointment, updateAppointment } from "./service";

const Extend = ({ id, close, date }) => {
  const [appointment, setAppointment] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getAppointment(id).then(setAppointment);
  }, [id]);

  const handleExtend = async () => {
    if (!appointment) return;
    updateAppointment(id, {
      time: appointment.time,
      duration: appointment.duration + selected,
    }).then(() => {
      close();
    });
  };

  if (!appointment) return null;

  const durations = [15, 30, 45, 60];

  return (
    <div className="fixed inset-0 z-[400] bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Extend appointment</h2>
          <button onClick={close} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        <div className="">
          <h3 className="text-lg font-semibold mb-4">Select duration</h3>
          <div className="flex justify-between mb-8">
            {durations.map((d, idx) => (
              <button
                key={d}
                onClick={() => setSelected(d)}
                className={`flex-1 px-8 py-3 rounded-md border border-gray-300 text-lg font-medium transition
                ${selected === d ? "bg-blue-600 border-blue-500 text-white" : "bg-white text-gray-800"}
                ${idx !== durations.length - 1 ? "mr-4" : ""}`}
              >
                {d}m
              </button>
            ))}
          </div>
          <div className="flex justify-between gap-4">
            <button
              className="px-8 py-3 rounded-full border border-gray-400 text-gray-800 font-medium bg-white transition"
              onClick={close}
            >
              Cancel
            </button>
            <button
              className={`px-8 py-3 rounded-full font-medium bg-blue-600 text-white transition
              ${selected ? "" : "opacity-50 cursor-not-allowed"}
            `}
              onClick={handleExtend}
              disabled={!selected}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Extend;
